export function generateCssString(selector: string, styles: Record<string, string>): string {
  let cssString = `${selector} {`
  for (const [property, value] of Object.entries(styles)) {
    cssString += `${property}: ${value}; `
  }
  cssString += '}'
  return cssString
}
